<script setup lang="ts">
// types
import type { BlockLinkCardProps } from '@ts-blocks/block-link-card/interfaces'
// hooks
import { useBlockLinkCard } from '@hooks/blocks/block-link-card.hook'
// components
import { Icon } from '@brighterly/lib-lumee-ui'
import { BrandShapeIcon } from '@UI/Brand/BrandShapeIcon'
import { AppIconStrapi } from '@UI/Icons/AppIconStrapi'

defineOptions({
  name: 'BlockLinkCard',
})

const props = defineProps<{
  block: BlockLinkCardProps
}>()

const {
  refHref,
  refPlateShape,
  refPlateColor,
  handleClick,
} = useBlockLinkCard({
  block: () => props.block,
})
</script>

<template>
  <a
    class="block-link-card"
    :class="`block-link-card--${block.discipline}`"
    :href="refHref"
    @click="handleClick"
  >
    <BrandShapeIcon
      class="block-link-card__plate"
      :shape="refPlateShape"
      :color="refPlateColor"
      size="md"
    >
      <AppIconStrapi
        v-if="block.icon"
        :icon="block.icon"
      />
      <Icon
        v-else
        name="t-rex"
        weight="solid"
        color="inherit"
      />
    </BrandShapeIcon>
    <span class="block-link-card__label btly-text-title-m">{{ block.label }}</span>
    <Icon
      class="block-link-card__arrow"
      name="arrow-right"
      size="lg"
      weight="solid"
      color="inherit"
    />
  </a>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockLinkCard.scss" />
